// Imports
import "lazysizes";
import Alpine from 'alpinejs';
import focus from '@alpinejs/focus'

window.Alpine = Alpine;
Alpine.plugin(focus);
Alpine.start();

// import Swiper JS
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
var swiper = new Swiper(".mySwiper", {
    modules: [Navigation, Pagination],
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    speed: 1000,
    keyboard: true,
    autoHeight: true
});

// Home page project types hover
const parents = document.querySelectorAll('.image-wrapper');
parents.forEach(parent => {
    let childTimeout;

    parent.addEventListener('mouseenter', () => {
        // Add class to parent on hover
        parent.classList.add('hovered'); 

        // After a 500ms delay, add class to the child element
        childTimeout = setTimeout(() => {
            parent.querySelector('.image-content').classList.add('content-active');
        }, 500);
    });

    parent.addEventListener('mouseleave', () => {
        // Clear the previous setTimeout if the mouse leaves before the delay is over
        clearTimeout(childTimeout);
        parent.querySelector('.image-content').classList.remove('content-active');

        // Add a delay of 500ms before removing the active class
        setTimeout(() => {
            parent.classList.remove('hovered');
        }, 500);

        // Remove the active class from the child element
        parent.querySelector('.image-content').classList.remove('content-active');
    });
});
